import { changeQuantity, updateSelection, updateKlarna } from "../../shop/connect";
import { getCookie } from "../../util/dom";
import { reloadGECheckout } from "../../components/global-e";
import { trackAddToCart, trackRemoveFromCart } from "../../components/stoked";
var cart = function cart() {
  var store = getCookie("esc_store", true);
  if (store && store.token !== undefined && window.sitewide.paymentReturnPage !== "".concat(window.location.origin).concat(window.location.pathname)) {
    updateSelection(store.token);
  }
  $(document).on("click", ".js-update-quantity", function (e) {
    if (e.currentTarget) {
      var $this = $(e.currentTarget);
      var action = $this.data("action");
      var line = $this.closest(".js-cartItem").data("line");
      var quantity = parseInt($this.closest(".js-cartItem").data("quantity"), 10),
        originalQuantity = quantity;
      if (action === "remove") {
        quantity = 0;
        $.event.trigger("stoked-remove-from-cart", [line, originalQuantity, trackRemoveFromCart]);
      } else if (action === "increase") {
        quantity += 1;
        $.event.trigger("stoked-add-to-cart", [line, quantity - originalQuantity, false, trackAddToCart]);
      } else if (action === "decrease") {
        quantity -= 1;
        $.event.trigger("stoked-remove-from-cart", [line, Math.abs(quantity - originalQuantity), trackRemoveFromCart]);
      }
      $("#js-cart-loader").removeClass("d-none");
      $this.closest(".js-cartItem").addClass("is-processing");
      changeQuantity(line, quantity).then(function (data) {
        if (window.CentraCheckout) {
          updateKlarna();
        }
        if (data.selection.items.length === 0) {
          $('body').removeClass('cart-overlay');
        }
        $("#js-cart-loader").addClass("d-none");
        reloadGECheckout();
      });
    }
  });
  cartToggle();
  cartListToggle();
};
var cartToggle = function cartToggle() {
  var cart = document.querySelector(".js-cart");
  if (!cart) {
    return;
  }
  var cartOpen = document.querySelector(".js-cart-open");
  var cartClose = document.querySelector(".js-cart-close");
  cartOpen.addEventListener("click", function () {
    document.body.classList.add("cart-is-open");
    cart.classList.add("is-expanded");
  });
  cartClose.addEventListener("click", function () {
    document.body.classList.remove("cart-is-open");
    cart.classList.remove("is-expanded");
  });
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".js-cart-open, .js-cart").length) {
      document.body.classList.remove("cart-is-open");
      cart.classList.remove("is-expanded");
    }
  });
};
var cartListToggle = function cartListToggle() {
  var cartListToggle = document.querySelector(".js-cart-list-toggle");
  if (!cartListToggle) {
    return;
  }
  var cartList = document.querySelector(".js-cart-list");
  cartListToggle.addEventListener("click", function () {
    this.classList.toggle("is-expanded");
    cartList.classList.toggle("is-expanded");
  });
};
export default cart;


// WEBPACK FOOTER //
// ./scripts/partials/top/cart.js